import React from 'react'

const Adeudadas = ({ adeudadas }) => {

    return (
        <div className='card m-3'>
            <div className='card-header text-center bg-danger'>
                Materias Que Me Faltan Cursar
            </div>
            <div
                className='card-body row'
            >
                <table className="table table-sm table-info text-center p-3 table-bordered border-primary">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Nivel</th>
                            <th scope="col">Materias</th>
                            <th scope="col">Horas</th>
                        </tr>
                    </thead>
                    <tbody>
                        
                    {
                        adeudadas.map(({ nivel, materia, horas }, i) =>
                            <tr className={nivel % 2 === 0 ? 'table-secondary' : 'table-dark'} key={i + 1} >
                                <th scope="row">{i + 1}</th>
                                <td>{nivel}</td>
                                <td>{materia}</td>
                                <td>{horas}</td>
                            </tr>
                        )
                    }

                    </tbody>
                </table>

            </div>
        </div>
    )
}

export default Adeudadas